import { Component } from '@angular/core';

@Component({
  selector: 'app-svg-sprite-def',
  templateUrl: './defs/sprite.defs.svg'
})
export class SvgSpriteDefComponent {}
